<app-report-header
  [selectedReportType]="selectedReportType"
  [headerType]="headerType"
  [scrollPosition]="scrollPosition"
  [backLinkText]="backLinkText"
  [backRouterLink]="backLinkRoute"
  (reportTypeChanged)="handleReportTypeChange($event)"
  (reportDropdownChanged)="handleReportListChanged($event)"
  [purchasedItemDto]="purchasedItemDtos"
  [reportRole]="reportRole"
></app-report-header>
@if (showTabularView()) {
  <div [ngClass]="{'preview-container': !isSelectedReportType(reportTypes.BOTH)}"
    >
    @for (purchasedItem of purchasedItemDtos; track purchasedItem; let i = $index; let first = $first; let last = $last) {
      <div [ngClass]="{'preview-container': isSelectedReportType(reportTypes.BOTH)}">
        @if (headerType === reportHeaderType.TABULAR) {
          @if (isSelectedReportType(reportTypes.AUTHORIZATION) || isSelectedReportType(reportTypes.BOTH)) {
            <app-report-content
              [isFirst]="first"
              [isLast]="last"
              [purchasedItem]="purchasedItem"
              [previewType]="reportTypes.AUTHORIZATION"
              [selectedReportType]="selectedReportType">
            </app-report-content>
          }
          @if (isSelectedReportType(reportTypes.BOTH)) {
            <hr class="preview-hr">
          }
          @if (isSelectedReportType(reportTypes.RECORD_OF_SALE) || isSelectedReportType(reportTypes.BOTH)) {
            <app-report-content
              [isFirst]="first"
              [isLast]="last"
              [purchasedItem]="purchasedItem"
              [previewType]="reportTypes.RECORD_OF_SALE"
              [selectedReportType]="selectedReportType">
            </app-report-content>
          }
        }
        @if (headerType === reportHeaderType.DROPDOWN) {
          @for (report of reportList; track report) {
            <app-report-content
              [isFirst]="first"
              [isLast]="last"
              [purchasedItem]="purchasedItem"
              [previewType]="report"
              [selectedReportType]="report"
              [sellerRemitDto]="findSellerRemitData(purchasedItem.auctionItemUuid)"
              [reportList]="reportList"
              >
            </app-report-content>
          }
        }
      </div>
    }
  </div>
} @else {
  <p>{{ this.textNoReportsSelected }}</p>
}

